export default {
  type: 'Type',
  reason: 'Reason',
  side: 'Side',
  area: 'Area',
  occuredAt: 'OccuredAt',
  comment: 'Comment',
  establishment: 'Establishment',
  department: 'Department',
  doctorName: 'Doctor Name',
  doctorComment: 'Doctor Comment',
  complications: 'Complications',
  intensity: 'Intensity',
  customType: 'Other Type',
  customReason: 'Other Reason',
  duration: 'Duration',
  hjhs: 'Hjhs',
  hjhsTotal: 'Hjhs Total',
  physiotherapist: 'Physiotherapist',
  physiotherapistComment: 'Physiotherapist Comment',
}
